<template>
  <avs-chip
    class="min-width-120"
    color="warning"
    icon="mdi-timer-sand-complete"
    iconColor="blue"
    text-color="blue"
  >
    {{ $t("commons.status.pending") }}
  </avs-chip>
</template>

<script>
export default {
  name: "PendingChip"
}
</script>
